<template>
  <div class="BarChart">

    <svg class="BarChart-svg"
      ref="svg"
      width="534"
      height="412">

    </svg>

  </div>
</template>

<script>
import * as d3 from 'd3'

export default {
  name: 'BarChart',

  props: {
    content: {
      type: Object,
      required: true
    }
  },

  mounted () {
    this.$nextTick(this.init)
  },

  methods: {
    /**
     * Initialize
     */
    init () {
      this.rect = this.$refs.svg.getBoundingClientRect()
      this.chart = d3.select(this.$refs.svg)

      this.defineScales()
      this.defineImageBackgrounds()
      this.addBars()
      this.addXAxis()
      this.addBarLabels()
    },

    /**
     * Define scales
     */
    defineScales () {
      this.xScale = d3.scaleBand()
        .domain(this.content.options.map((d, i) => { return i }))
        .rangeRound([0, this.rect.width])
        .paddingInner(0.25)

      this.yScale = d3.scaleLinear()
        .domain([0, d3.max(this.content.options, d => { return d.value })])
        .range([0, this.rect.height - 30])
    },

    /**
     * Define image backgrounds
     */
    defineImageBackgrounds () {
      const defs = this.chart.append('defs')

      defs.selectAll('pattern')
        .data(this.content.options)
        .enter()
        .append('pattern')
          .attr('id', (d, i) => { return `image-${i}` })
          .attr('patternContentUnits', 'userSpaceOnUse')
          .attr('width', '100%')
          .attr('height', '100%')
          .append('image')
          .attr('xlink:href', d => { return this.content.image })
    },

    /**
     * Add bars to chart
     */
    addBars () {
      const g = this.chart.append('g')

      g.selectAll()
        .data(this.content.options)
        .enter()
        .append('rect')
          .attr('class', d => {
            let classes = this.class('bar')
            classes += d.correct ? ` ${this.class('bar--isCorrect')}` : ` ${this.class('bar--isIncorrect')}`
            return classes
          })
          .attr('fill', (d, i) => {
            if (!this.content.image) return
            return `url(#image-${i})`
          })
          .attr('x', (d, i) => { return this.xScale(i) })
          .attr('y', () => { return this.rect.height - 30 })
          .attr('width', this.xScale.bandwidth())
          .attr('height', 0)
          .transition()
            .duration(500)
            .delay((d, i) => { return i * 50 })
            .ease(d3.easeQuad)
          .attr('y', d => {
            return this.rect.height - 30 - this.yScale(d.value)
          })
          .attr('height', d => { return this.yScale(d.value) })
    },

    /**
     * Add x-axis labels
     */
    addXAxis () {
      const g = this.chart.append('g')

      g.selectAll()
        .data(this.content.options)
        .enter()
        .append('text')
          .attr('class', this.class('xLabel'))
          .attr('text-anchor', 'middle')
          .attr('x', (d, i) => {
            return this.xScale(i) + (this.xScale.bandwidth() / 2)
          })
          .attr('y', d => {
            return this.rect.height - 4
          })
          .text(d => { return d.axisLabel })
    },

    /**
     * Add bar labels
     */
    addBarLabels () {
      const g = this.chart.append('g')

      g.selectAll()
        .data(this.content.options)
        .enter()
        .append('text')
          .attr('class', this.class('barLabel'))
          .attr('text-anchor', 'middle')
          .attr('x', (d, i) => {
            return this.xScale(i) + (this.xScale.bandwidth() / 2)
          })
          .attr('y', d => {
            return this.rect.height - 40 - this.yScale(d.value) + 50
          })
          .text(d => {
            if (this.yScale(d.value) < 60) return
            return d.label
          })
          .attr('opacity', 0)
          .transition()
            .duration(500)
            .delay((d, i) => { return 500 })
            .ease(d3.easeQuad)
          .attr('opacity', 1)
    },

    /**
     * Return component-prefixed class
     * @param {String} name
     * @return {String}
     */
    class (name) {
      return `BarChart-${name}`
    }
  }
}
</script>

<style>
.BarChart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 652px;
  text-align: center;
}

.BarChart-svg {
  width: 534px;
  height: 412px;
}

.BarChart-bar {

}

.BarChart-bar--isIncorrect {
  fill: var(--color-2);
}

.BarChart-barLabel {
  font-size: 28px;
  line-height: 1;
  fill: var(--color-1);
}

.BarChart-xLabel {
  font-size: 16.5px;
  line-height: 1;
  fill: var(--color-3);
}
</style>



// WEBPACK FOOTER //
// BarChart.vue?40b25f61